module.exports = __webpack_public_path__ + "static/4-4d6770d78efbaa0fbbaffcdec2755c80.jpeg";